import { VmView } from "components"
import { useState } from "react"

export const ModalCariEtiket = ({
  isOpen,
  onClose,
  items,
  onSelectEtiket = () => {},
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  // Filter items berdasarkan searchTerm
  const filteredItems = items.filter(
    item =>
      item.etinama.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.etiketerangan.toLowerCase().includes(searchTerm.toLowerCase())
  )

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-3">
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <VmView className="bg-white rounded-lg shadow-lg p-6 z-10 w-full md:w-1/2">
        <h2 className="text-xl font-semibold mb-4">Pilih Etiket</h2>

        {/* Search Bar */}
        <div className="mb-4">
          <input
            type="text"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Cari etiket..."
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <VmView className="max-h-[70vh] overflow-auto">
          {filteredItems.length > 0 ? (
            filteredItems.map((item, index) => (
              <VmView
                key={index}
                className="mb-4 border-b-2 pb-2 flex justify-between items-center"
              >
                <div>
                  <label className="block text-gray-900 mb-1">
                    {item.etinama}
                  </label>
                  <label className="block text-gray-700 mb-1 text-sm">
                    {item.etiketerangan}
                  </label>
                </div>
                <button
                  onClick={() => onSelectEtiket(item)}
                  className="bg-blue-500 text-white text-xs p-1 rounded-lg"
                >
                  Pilih
                </button>
              </VmView>
            ))
          ) : (
            <div className="text-gray-500">
              Tidak ada etiket yang ditemukan.
            </div>
          )}
        </VmView>

        <button
          onClick={onClose}
          className="mt-4 bg-blue-500 text-white p-2 rounded-lg"
        >
          Tutup
        </button>
      </VmView>
    </div>
  )
}
